import "./App.css";
import FertilityQuiz from "./FertilityQuiz";

function App() {
  return (
    <div className="App">
      <FertilityQuiz />
    </div>
  );
}

export default App;
